import BrandMark from "./../BrandMark";

function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export default function PublicReportHeader({ propertyAddress, finalizedAt }) {
  return (
    <header
      data-testid="public-report-header"
      className="border-b-2 border-slate-900 pb-6 mb-8 flex items-start justify-between gap-6 flex-wrap"
    >
      <div className="flex items-center gap-3">
        <BrandMark size={56} />
        <div>
          <div className="font-heading text-base font-bold tracking-tight text-slate-900">
            ZION SOLAR
          </div>
          <div className="text-[11px] uppercase tracking-wider text-amber-700 font-semibold mt-0.5">
            Service · Diagnostic Report
          </div>
        </div>
      </div>
      <div className="text-right text-xs text-slate-700 leading-relaxed">
        {propertyAddress && (
          <div>
            <div className="text-[10px] uppercase tracking-wider text-slate-500 font-bold">
              Property
            </div>
            <div className="font-semibold text-slate-900">
              {propertyAddress}
            </div>
          </div>
        )}
        <div className="mt-2">
          <div className="text-[10px] uppercase tracking-wider text-slate-500 font-bold">
            Finalized
          </div>
          <div className="font-semibold text-slate-900">
            {fmtDate(finalizedAt)}
          </div>
        </div>
      </div>
    </header>
  );
}
